import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/scrolling';

class RefreshUviDialogData {
	readingDate: Date;
}

@Component({
	selector: 'refresh-uvi-dialog',
	templateUrl: 'refresh-uvi-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		TranslocoDirective,
		MatIconButton,
		MatDialogClose,
		MatIcon,
		MatDialogTitle,
		CdkDrag,
		CdkDragHandle,
		CdkScrollable,
		MatDialogContent,
		MatDialogActions,
		MatButton,
	],
})
export class RefreshUviDialogComponent {
	dialogRef = inject<MatDialogRef<RefreshUviDialogComponent>>(MatDialogRef);
	data = inject<RefreshUviDialogData>(MAT_DIALOG_DATA);
}
